import { IconButton, InputAdornment, MenuItem, TextField } from "@mui/material";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

export const CustomTextField = ({
  field,
  value,
  options,
  onChange,
  readOnly,
  link,
  disableClear,
  ...rest
}) => {
  const { t } = useTranslation("main");
  const isSelect = Array.isArray(options) && options.length > 0;

  if (link && !value) return;

  // return <TextField label="EUU" value={value ?? ""} />;

  return (
    <TextField
      {...rest}
      value={value ?? ""}
      onChange={(e) => {
        if (onChange) onChange(field)(e);
      }}
      label={readOnly ? `${t(field)} (${t("read_only")})` : t(field)}
      fullWidth
      select={isSelect} // Solo es select si hay opciones
      InputProps={{
        endAdornment: value && !readOnly && !disableClear && (
          <InputAdornment
            position="end"
            style={{ marginRight: isSelect ? "20px" : "" }}
          >
            <IconButton
              onClick={() => onChange(field)("")}
              size="small"
              style={{
                width: "0.9rem",
                height: "0.9rem",
              }}
            >
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      // InputLabelProps={{ shrink: true }}
      // {...(readOnly && {
      //   slotProps: { input: { readOnly: true } },
      // })}
      variant={readOnly ? "standard" : "outlined"}
      sx={{
        "& .MuiInputBase-inputAdornedEnd": {
          paddingRight: "0!important", // Cambia esto a la propiedad que quieras modificar
        },
      }}
      multiline
    >
      {isSelect
        ? options.map((option) => (
            <MenuItem key={option} value={option}>
              {t(option)}
            </MenuItem>
          ))
        : null}
    </TextField>
  );
};
